import Repository from "../Repository";
import { getAuthHeader } from "../../_helpers/apiHelper";

const resource = "/device";

export default {
  get(user, companyId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/${companyId}/all`, config);
  },

  getById(user, deviceId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/${deviceId}`, config);
  },

  create(user, companyId, payload) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.post(`${resource}/${companyId}`, payload, config);
  },

  update(user, deviceId, payload) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.put(`${resource}/${deviceId}`, payload, config);
  },

  delete(user, deviceId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.delete(`${resource}/${deviceId}`, config);
  },

  getKeys(user, deviceId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/${deviceId}/keys`, config);
  },

  getFieldsForDevice(user, deviceId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/${deviceId}/fields`, config);
  },

  getPool(user) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/pool`, config);
  },

  setPool(user, companyId, deviceId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.post(
      `${resource}/pool/${deviceId}/company/${companyId}`,
      null,
      config
    );
  },

  getMetas(user, deviceId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.get(`${resource}/meta/${deviceId}`, config);
  },

  createMeta(user, deviceId, payload) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.post(`${resource}/meta/${deviceId}`, payload, config);
  },

  deleteMeta(user, deviceMetaId) {
    var config = {
      headers: getAuthHeader(user),
    };

    return Repository.delete(`${resource}/meta/${deviceMetaId}`, config);
  },
};
